const navigation = [
  { name: 'Mandat', href: '/', current: true },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function VNav({ email, onSignOut, onSignOutRedirect }) {
  return (
    <nav
      aria-label="Sidebar"
      className="fixed top-0 left-0 h-screen w-40 bg-white dark:bg-gray-900 z-10 overflow-y-auto"
    >
      {email && (
        <div className="absolute top-0 left-0 w-full p-2 text-xs text-gray-500 dark:text-gray-400 text-center bg-gray-100 dark:bg-gray-800">
          Logged in as {email}
        </div>
      )}
      <ul role="list" className="flex flex-col ml-2 justify-center h-full">
        {navigation.map((item) => (
          <li key={item.name}>
            <a
              href={item.href}
              className={classNames(
                item.current
                  ? 'bg-gray-50 text-indigo-600 dark:bg-white/5 dark:text-white'
                  : 'text-gray-700 hover:bg-gray-50 hover:text-indigo-600 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white',
                'group flex gap-x-3 rounded-md p-2 pl-3 text-sm/6 font-semibold',
              )}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>
      <div className="absolute bottom-0 left-0 w-full p-2">
        <button
          onClick={() => {
            onSignOut(); // Remove user session
            onSignOutRedirect(); // Redirect to logout URL
          }}
          className={classNames(
            'text-gray-700 hover:bg-gray-50 hover:text-indigo-600 dark:text-gray-300 dark:hover:bg-white/5 dark:hover:text-white',
            'group flex w-full gap-x-3 rounded-md p-2 pl-3 text-sm/6 font-semibold text-left'
          )}
        >
          Logout
        </button>
      </div>
    </nav>
  );
}